import { render, staticRenderFns } from "./FormModalSSOIModal.vue?vue&type=template&id=1ef3bae1"
import script from "./FormModalSSOIModal.vue?vue&type=script&lang=js"
export * from "./FormModalSSOIModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports